module.exports = __webpack_public_path__ + "static/img/home-item4.96cd83d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-item4.png
// module id = 7I1k
// module chunks = 21